export default __webpack_public_path__ + "images/posterior_blue.caa17c8c9aa725cd119dd4f282ee6772.png";